import PropTypes from 'prop-types'
import { Link } from 'react-router-dom'

import Icon from '../Icon/Icon'
import './CollectionCard.scss'

export const CollectionCard = ({ locale, collection }) => {
  return (
    <>
      {collection.title && collection.description && (
        <div className="c-collection-card">
          <Link
            className="c-collection-card__link"
            to={`/${locale}/collections/${collection.slug}`}
          >
            <img
              alt=""
              className="c-collection-card__image"
              src={collection.heroImage}
            />
            <div className="c-collection-card__content">
              <p className={'c-collection-card__title'}>
                {collection.title} <Icon type="chevron-right" />
              </p>
              <div className="c-collection-card__body">
                {collection.description}
              </div>
            </div>
          </Link>
        </div>
      )}
    </>
  )
}

CollectionCard.propTypes = {
  locale: PropTypes.string.isRequired,
  collection: PropTypes.object.isRequired,
}

export default CollectionCard
